import Vue from 'vue';

import versionedConceptsApi from '../../firebase/versionedConcepts';
import PluggableModule from '../pluggable';

const versionedConcepts = new PluggableModule('publishedConcept');

const ucName = versionedConcepts.name.toUpperCase();
const SET_CONCEPT_ID = `${ucName}_SET_CONCEPT_ID`;
const ADD_VERSION_KEY = `${ucName}_ADD_VERSION_KEY`;
const CLEAR_VERSIONS = `${ucName}_CLEAR_VERSIONS`;
const LOAD_VERSION_INIT = `${ucName}_LOAD_VERSION_INIT`;
const LOAD_VERSION_ERROR = `${ucName}_LOAD_VERSION_ERROR`;
const LOAD_VERSION_DONE = `${ucName}_LOAD_VERSION_DONE`;

versionedConcepts.extend({
  namespaced: true,
  state: {
    conceptId: null,
    loaded: {},
    loading: false,
    loadError: {}
  },
  mutations: {
    [SET_CONCEPT_ID](state, conceptId) {
      state.conceptId = conceptId;
    },
    [ADD_VERSION_KEY](state, version) {
      Vue.set(state.loaded, version, null);
      Vue.set(state.loadError, version, null);
    },
    [CLEAR_VERSIONS](state) {
      state.loaded = {};
      state.loadError = {};
    },
    [LOAD_VERSION_INIT](state, { version }) {
      state.loading = true;
      state.loadError[version] = null;
    },
    [LOAD_VERSION_ERROR](state, { version, error }) {
      state.loading = false;
      state.loadError[version] = error;
    },
    [LOAD_VERSION_DONE](state, { version, data }) {
      state.loading = false;
      state.loaded[version] = data;
    }
  },
  getters: {
    listedVersions(state) {
      return Object.keys(state.loaded);
    }
  },
  actions: {
    setConcept({ commit, state }, conceptId) {
      if (state.conceptId !== conceptId) {
        commit(CLEAR_VERSIONS);
        commit(SET_CONCEPT_ID, conceptId);
      }
    },
    async loadVersion({ commit, state }, version) {
      commit(LOAD_VERSION_INIT, { version });
      try {
        commit(ADD_VERSION_KEY, version);
        const data = await versionedConceptsApi.get(
          `${state.conceptId}_${version}`
        );
        commit(LOAD_VERSION_DONE, { version, data });
      } catch (error) {
        commit(LOAD_VERSION_ERROR, { version, error });
      }
    }
  }
});

export default versionedConcepts;
